




























































import { Component, Vue } from "vue-property-decorator";
import { login, accountPower, userPhone, userPhonesms } from "@/req/user";

@Component
export default class Home extends Vue {
  public username = "";
  public password = "";
  public phoneCode: any = "";
  public userIp = -1;
  public userPhone: any = "";
  public timeout: any = null;
  public times = 0;
  public accountBlur() {
    if (this.username != "") {
      this.debounce(this.getAccountPhone, 300);
    }
  }
  public debounce(func, wait) {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      func();
    }, wait);
  }
  public async getAccountPhone() {
    const res = await userPhone({
      username: this.username,
    });
    if (res.code == 0) {
      this.userIp = res.data.check_ip;
      this.userPhone = res.data.phone;
      if (res.data.check_ip == 0) {
        this.getCode();
      }
    } else {
      this.userIp = -1;
      this.userPhone = "";
    }
  }
  public async getCode() {
    const obj: any = {
      account: this.username,
    };
    const res = await userPhonesms(obj);
    if (res.code == 0) {
      this.$Modal.info({
        title: "验证码已发送，请注意查收",
        content: "",
      });
      this.times = 60;
      this.smsCountDown();
    } else {
      this.$Message.error(res.msg);
    }
  }
  public smsCountDown() {
    const time = setTimeout(() => {
      this.times--;
      if (this.times < 1) {
        this.userIp = -1;
        clearTimeout(time);
      } else {
        this.smsCountDown();
      }
    }, 1000);
  }
  public async toLogin() {
    setTimeout(() => {
      this.logins();
    }, 500);
  }
  public async logins() {
    const res = await login({
      username: this.username,
      password: encodeURIComponent(this.password),
      code: this.userIp == 1 ? 1 : this.phoneCode,
      phone: this.userIp == 1 ? 1 : this.userPhone,
    });
    if (res.code == 0) {
      this.$fn.cookies.setToken(res.data.token);
      this.$Message.success(res.msg);
      if (res.data.default_path) {
        return this.$router.push(`/${res.data.default_path}`);
      }
      // this.$store.dispatch("user/authInfo", res.data.userinfo);
      this.getPowerList();
    }
  }
  public async getPowerList() {
    const res = await accountPower({
      token: this.$fn.cookies.getToken("tpken"),
    });
    if (res.code == 0) {
      if (res.data.permission[0] == undefined) {
        this.$Message.error("请联系管理员确认账号权限！");
        return false;
      }
      for (let i = 0; i < res.data.permission.length; i++) {
        if (res.data.permission[i].id == 82) {
          const str = res.data.permission[i];
          res.data.permission.splice(i, 1);
          res.data.permission.unshift(str);
        }
      }
      this.$store.state.user.menu = res.data.permission;
      const list = res.data.permission_uri.filter((item) => {
        return item == "/dataGeneralization" || item == "/transactionMoney";
      });
      if (list[0] == undefined) {
        this.$router.push(res.data.permission_uri[0]);
      } else {
        this.$router.push(list[0]);
      }
    }
  }
}
